import { ReactNode, useContext } from "react";

export const isNodeEmpty = (node: ReactNode): boolean => {
  if (
    node === null ||
    node === undefined ||
    node === false ||
    node === "" ||
    (Array.isArray(node) && node.every(isNodeEmpty))
  ) {
    return true;
  }

  if (typeof node === "object" && !Array.isArray(node)) {
    return Object.keys(node).length === 0;
  }

  return false;
};

export function useNonNullableContext<T>(context: React.Context<T>): NonNullable<T> {
  const maybeContext = useContext(context);
  if (maybeContext === null || maybeContext === undefined) {
    throw new Error(`Context "${context.displayName}" was used without a Provider`);
  }
  return maybeContext;
}
